import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=7064f90c"
import script from "./ServiceList.vue?vue&type=script&lang=js"
export * from "./ServiceList.vue?vue&type=script&lang=js"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=7064f90c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports